import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  Chip,
  Collapse,
  TextField,
  Grid,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import { useState, useEffect } from "react";
import { get, post } from "../../../../utils/api";
import SelectField from "../../../../Components/Masters/SelectField";
import formatTitleWithOptional from "../../OptionalFeild";
import InputField from "../../../../Components/Masters/InputField";
import InputDate from "../../../../Components/Masters/InputDate";

const BulkUploadAdd = ({
  matchData,
  onClose,
  onConfirm,
  onAddItem,
  setMatchData,
  validateForm,
  index,
  formData,
  errors,
  setErrors,
  setFormData,
  setExpandedRows,
  bulkuploadInputData,
  url,
  submitUrl,
  fuelType,
  equipment,  
  setsnackOpen,
}) => {
  const [equipmentDetails, setEquipmentDetails] = useState([]);

  console.log("DEBUG - errors:", errors, "index:", index, "errors[index]:", errors?.[index], "formData[index]:", formData?.[index]);

  const unitOptions = {
    "Diesel (average biofuel blend)": ["Km/Liter"], // Example units for Diesel
    "Diesel (100% mineral diesel)": ["Km/Liter"],
    "Petrol (average biofuel blend)": ["Km/Liter"],
    "Petrol (100% mineral petrol)": ["Km/Liter"],
    CNG: ["Km/Kg"], // Example for CNG
    Electricity: ["Km/Kwh"], // Example for Electricity
  };

  const handleChange = (e, type) => {
    const { name, value } = e.target;
    if (type === "number" && !/^\d*$/.test(value)) return;
    
    // Clear the specific error for the field being changed
    setErrors((prevErrors) => ({
      ...prevErrors,
      [index]: {
        ...prevErrors[index],
        [name]: undefined, // Remove error for the specific field
        ...(name==="fuelType" && {
          ["declaredEfficiency.unit"]: undefined,
        })  ,
      },
    }));
    if (name.startsWith("declaredEfficiency.")) {
      const [field, key] = name.split(".");
      console.log(field, key);

      setFormData((prevState) => ({
        ...prevState,
        [field]: {
          ...prevState[field],
          [key]: value,
        },
      }));

      setErrors((prevState) => ({
        ...prevState,
        [field]: {
          ...prevState[field],
          [key]: "",
        },
      }));
    } else {
      if (name === "vehicleNumber") {
        const regex = new RegExp(`^${value}$`, "i"); // 'i' flag makes it case-insensitive
        const vehicle = equipmentDetails.filter((el) => regex.test(el.vehicleNumber));

        // Check if the GST Number already exists and the IDs don't match (or if no GST record exists, skip the validation)
        if (
          vehicle.length > 0 &&
            (equipment ? equipment?._id !== vehicle[0]?._id : true)
        ) {
          setErrors({
            ...errors,
            [index]: {
              ...errors[index],
              [name]: "Vehicle Number already exists.",
            },
          });
        }

        return;
      }

      // Handling specific conditions based on field names
      if (name === "transportType") {
        if (value === "Passenger") {
          setFormData((prev) => ({
            ...prev,
            [index]: {
              ...prev[index],
              transportType: value,
            },
            loadCapacity: "",
            vehicleCategory: "",
          }));
        } else if (value === "Freight") {
          setFormData((prev) => ({
            ...prev,
            [index]: {
              ...prev[index],
              transportType: value,
            },
            passengerCapacity: "",
            ownership: "Leased",
            // logisticsVendor:prev.logisticsVendor ||  "",
          }));
        }
      }

      // Handling specific conditions based on field names
      if (name === "ownership") {
        // If ownership is set to "Leased", show the logisticsVendor field
        if (value !== "Leased") {
          setFormData((prev) => ({
            ...prev,
            [index]: {
              ...prev[index],
              ownership: value,
            },
            logisticsVendor: "", // Make sure logisticsVendor is set if it's not already
          }));
        }
      }

      if (name === "fuelType") {
        setFormData((prevState) => ({
          ...prevState,
          declaredEfficiency: {
            ...prevState.declaredEfficiency,
            [index]: {
              ...prevState[index],
              fuelType: value,
            },
            unit: unitOptions[value]?.[0],
          },
        }));

        setErrors((prevState) => ({
          ...prevState,
          declaredEfficiency: {
            ...prevState.declaredEfficiency,
            [index]: {
              ...prevState[index],
              fuelType: value,
            },
            unit: "",
          },
        }));
      }
    }
    setFormData((prev) => {
      const current = prev[index] || {};
      const updatedFuelType = name === "fuelType" ? value : current.fuelType;

      return {
        ...prev,
        [index]: {
          ...current,
          fuelType: updatedFuelType,
          vehicleNumber: equipment,
          [name]: value,
          ...(name === "fuelType" && {
            declaredEfficiency: {
              ...current.declaredEfficiency,
              unit: unitOptions[updatedFuelType]?.[0] || "",
            },
          }),
        },
      };
    });

    if (name === "noOfEquipment") {
      handleNoOfEquipmentChange(value);
    }
  };

  const handleDateChange = (e) => {
    const { name, value } = e; // Correctly extract name and value from e.target

    if (name === "purchaseDate" && formData.lastServiceDate < value)
      setFormData((prev) => ({
        ...prev,
        [index]: {
          ...prev[index],
          lastServiceDate: "",
        },
      }));

    // Clear the specific error for the field being changed
    setErrors((prevErrors) => ({
      ...prevErrors,
      [index]: {
        ...prevErrors[index],
        [name]: undefined, // Remove error for the specific field
      },
    }));

    setFormData((prevState) => ({
      ...prevState,
      [index]: {
        ...prevState[index],
        [name]: value,
      },
    }));
  };

  const handleNoOfEquipmentChange = (value) => {
    const num = parseInt(value) || 0;
    if (num < 0) return;

    // Initialize equipment details array
    const details = Array(num)
      .fill()
      .map(() => ({
        uniqueID: "",
        brand: "",
        model: "",
        ratedFuelConsumption: "",
        unitOfFuelConsumption: "",
      }));

    setEquipmentDetails(details);
  };

  const handleAddItem = async (index) => {
    if (!validateForm(index)) {
      return;
    }

    const itemData = {
      //   equipment: matchData[index].equipment,
      ...formData[index],
    };

    try {
      // Make API call here
      // Example: const response = await addEquipmentAPI(itemData);
      const response = await post(submitUrl, itemData);
      // For now, simulate API call success
      setsnackOpen({
        open: true,
        message: response.data.message,
        severity: "success",
      });

      await new Promise((resolve) => setTimeout(resolve, 1000));

      // Update the status to matched on success
      if (setMatchData) {
        setMatchData((prev) =>
          prev.map((item, i) =>
            i === index ? { ...item, matched: true } : item
          )
        );
      }

      // Call the parent handler if provided
      if (onAddItem) {
        onAddItem(itemData, index);
      }

      // Close the expanded row
      setExpandedRows((prev) => ({
        ...prev,
        [index]: false,
      }));

      // Clear form data and errors for this index
      setFormData((prev) => {
        const newData = { ...prev };
        delete newData[index];
        return newData;
      });

      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[index];
        return newErrors;
      });
    } catch (error) {
      console.error("Error adding vehicle:", error);
      // Handle error - you can show an error message here
    }
  };
  return (
    <Box
      sx={{
        margin: 1,
        // backgroundColor: "#f8f9fa",
      }}
    >
      <Typography variant="h6" gutterBottom component="div">
        Add Vehicle: {equipment}
      </Typography>
      <Grid container spacing={2}>
        {bulkuploadInputData?.map((items, i) => {
          if (
            items.fieldName === "ownership" &&
            formData?.[index]?.transportType === "Freight"
          ) {
            return null;
          }
          if (
            items.fieldName === "vehicleCategory" &&
              formData?.[index]?.transportType === "Passenger"
          ) {
            return null;
          }
          if (
            items.fieldName === "loadCapacity" &&
            formData?.[index]?.transportType === "Passenger" 
          ) {
            return null;
          }
          if (
            items.fieldName === "passengerCapacity" &&
           formData?.[index]?.transportType === "Freight"
          ) {
            return null;
          }
          if (
            items.fieldName === "logisticsVendor" &&
            formData?.[index]?.ownership === "Company Owned"
          ) {
            return null;
          }
          return (
            <Grid item xs={12} sm={6} key={i}>
              {items.type === "text" || items.type === "number" ? (
                <InputField
                  title={items.title}
                  handleChange={(e) => handleChange(e, items.type)}
                  placeholder={items.placeholder}
                  value={
                    items.fieldName === "vehicleNumber"
                      ? equipment
                      : formData?.[index]?.[items.fieldName] || ""
                  }
                  fieldName={items.fieldName}
                  disabled={items?.disabled}
                  type={items.type}
                  errors={errors?.[index]?.[items.fieldName]}
                />
              ) : items.fieldName === "vehicleType" ? (
                <SelectField
                  title={items.title}
                  name={items.fieldName}
                  value={formData[index]?.[items.fieldName] || ""}
                  handleChange={(e) => handleChange(e, items.type)}
                  options={
                    items.fieldName === "vehicleType"
                      ? formData?.[index]?.vehicleCategory
                        ? (formData?.[index]?.vehicleCategory ===
                            "Heavy Commercial Vehicles (HCV)" && [
                            "Heavy Duty Trucks",
                            "Tanker Trucks",
                            "Refrigerated trucks",
                          ]) ||
                          (formData?.[index]?.vehicleCategory ===
                            "Medium Commerical Vehicles (MCV)" && [
                            "Medium Duty trucks",
                            "Flatbed trucks",
                          ]) ||
                          (formData?.[index]?.vehicleCategory ===
                            "Light Commerical Vehicles (LCV)" && [
                            "Light duty trucks",
                          ])
                        : formData?.[index]?.transportType === "Passenger" && [
                            "Sedan",
                            "SUV",
                            "Hatchback",
                            "Motorcycle / Scooter",
                            "Bus - Heavy",
                            "Bus - Medium ",
                          ]
                      : items.options
                  }
                  errors={errors?.[index]?.[items.fieldName]}
                  url={items.selectUrl}
                  field={items.field}
                  disable={
                    !formData?.[index]?.vehicleCategory &&
                    (!formData?.[index]?.transportType ||
                      formData?.[index]?.transportType !== "Passenger")
                      ? true
                      : false
                  }
                />
              ) : items.fieldName === "declaredEfficiency" ? (
                <Box display="flex" gap={1} sx={{ width: "100%" }}>
                  <Box sx={{ width: "60%" }}>
                    <InputField
                      title={items.title}
                      handleChange={(e) => {
                        const { name, value } = e.target;
                        const [main, sub] = name.split(".");
                        if (!/^\d*$/.test(value)) return;
                        
                        // Clear the specific error for the field being changed
                        setErrors((prevErrors) => ({
                          ...prevErrors,
                          [index]: {
                            ...prevErrors[index],
                            [main]: {
                              ...prevErrors[index]?.[main],
                              [sub]: undefined, // Remove error for the specific nested field
                            },
                          },
                        }));
                        
                        setFormData((prev) => {
                          const prevItem = prev[index] || {};

                          // If field is declaredEfficiency.value, update unit too
                          const shouldSetUnit = main === "declaredEfficiency";

                          return {
                            ...prev,
                            [index]: {
                              ...prevItem,
                              [main]: {
                                ...prevItem[main],
                                [sub]: value,
                              },
                            },
                          };
                        });
                      }}
                      placeholder={items.placeholder}
                      value={formData?.[index]?.[items.fieldName]?.value || ""}
                      errors={errors?.[index]?.[items.fieldName]?.value} // Access error for value
                      fieldName={`${items.fieldName}.value`}
                    />
                  </Box>
                  <Box sx={{ width: "40%", mt: "1.8rem" }}>
                    <InputField
                      name={`${items.fieldName}.unit`}
                      value={formData?.[index]?.declaredEfficiency?.unit}
                      placeholder={"Unit"}
                      options={unitOptions[formData?.[index]?.fuelType] || []}
                      errors={errors?.[index]?.[items.fieldName]?.unit} // Access error for unit
                      field={`${items.field}.unit`}
                      disabled={true}
                      defaultValue="Select Unit"
                    />
                  </Box>
                </Box>
              ) : items.type === "date" ? (
                <InputDate
                  title={items.title}
                  name={items.fieldName}
                  lastServiceDate={formData?.[index]?.lastServiceDate}
                  purchaseDate={formData?.[index]?.purchaseDate}
                  disable={
                    items.fieldName === "lastServiceDate" &&
                    formData?.[index]?.purchaseDate === ""
                  }
                  value={formData?.[index]?.[items.fieldName]}
                  handleChange={handleDateChange}
                  errors={errors?.[index]?.[items.fieldName]}
                />
              ) : (
                <SelectField
                  title={items.title}
                  name={items.fieldName}
                  value={formData?.[index]?.[items.fieldName] || ""}
                  handleChange={(e) => handleChange(e, items.type)}
                  options={items.options}
                  errors={errors?.[index]?.[items.fieldName]}
                  url={items.url}
                  field={items.field}
                />
              )}
            </Grid>
          );
        })}
        <Grid item xs={12}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleAddItem(index)}
              sx={{ mt: 1 }}
            >
              Add Vehicle
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
export default BulkUploadAdd;
